'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionsForFilterSet = exports.FILTER_WRITE_ACTIONS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends20 = require('babel-runtime/helpers/extends');

var _extends21 = _interopRequireDefault(_extends20);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOGGLE_FILTER_COLLAPSE = 'classpass/filters/TOGGLE_FILTER_COLLAPSE';
var SET_CLEAN = 'classpass/filters/SET_CLEAN';
var COLLAPSE_FILTER = 'classpass/filters/COLLAPSE_FILTER';
var EXPAND_FILTER = 'classpass/filters/EXPAND_FILTER';
var ADD_FILTER = 'classpass/filters/ADD_FILTER';
var CLEAR_FILTER = 'classpass/filters/CLEAR_FILTER';
var TOGGLE_ITEM_ID = 'classpass/filters/TOGGLE_ITEM_ID';
var TOGGLE_FILTER_PARENT_COLLAPSE = 'classpass/filters/TOGGLE_FILTER_PARENT_COLLAPSE';
var SET_FILTER_VALUE = 'classpass/filters/SET_FILTER_VALUE';
var SET_ITEM_ID_SELECTED = 'classpass/filters/SET_ITEM_ID_SELECTED';

var FILTER_WRITE_ACTIONS = exports.FILTER_WRITE_ACTIONS = [CLEAR_FILTER, TOGGLE_ITEM_ID, SET_FILTER_VALUE, SET_ITEM_ID_SELECTED];

var toggleFilterCollapse = function toggleFilterCollapse(filterSetId, filter) {
  return { type: TOGGLE_FILTER_COLLAPSE, data: { filterSetId: filterSetId, filter: filter } };
};
var toggleFilterSetCollapse = function toggleFilterSetCollapse(filterSetId) {
  return toggleFilterCollapse(filterSetId);
};
var collapseFilter = function collapseFilter(filterSetId, filter) {
  return { type: COLLAPSE_FILTER, data: { filterSetId: filterSetId, filter: filter } };
};
var collapseFilterSet = function collapseFilterSet(filterSetId) {
  return collapseFilter(filterSetId);
};
var expandFilter = function expandFilter(filterSetId, filter) {
  return { type: EXPAND_FILTER, data: { filterSetId: filterSetId, filter: filter } };
};
var expandFilterSet = function expandFilterSet(filterSetId) {
  return expandFilter(filterSetId);
};
var addFilter = function addFilter(filterSetId, filter, items, relationships, options) {
  return {
    type: ADD_FILTER,
    data: {
      filterSetId: filterSetId, filter: filter, items: items, relationships: relationships, options: options
    }
  };
};
var setClean = function setClean(filterSetId) {
  return { type: SET_CLEAN, data: { filterSetId: filterSetId } };
};
var clearFilter = function clearFilter(filterSetId, filter) {
  return { type: CLEAR_FILTER, data: { filterSetId: filterSetId, filter: filter } };
};
var clearFilterSet = function clearFilterSet(filterSetId) {
  return clearFilter(filterSetId);
};
var toggleItemId = function toggleItemId(filterSetId, filter) {
  for (var _len = arguments.length, itemIds = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    itemIds[_key - 2] = arguments[_key];
  }

  return { type: TOGGLE_ITEM_ID, data: { filterSetId: filterSetId, filter: filter, itemIds: itemIds } };
};
var setItemIdSelected = function setItemIdSelected(filterSetId, filter) {
  for (var _len2 = arguments.length, itemIds = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    itemIds[_key2 - 2] = arguments[_key2];
  }

  return { type: SET_ITEM_ID_SELECTED, data: { filterSetId: filterSetId, filter: filter, itemIds: itemIds } };
};
var setFilterValue = function setFilterValue(filterSetId, filter, value) {
  return { type: SET_FILTER_VALUE, data: { filterSetId: filterSetId, filter: filter, value: value } };
};

var toggleFilterParentCollapse = function toggleFilterParentCollapse(filterSetId, filter, itemId) {
  return { type: TOGGLE_FILTER_PARENT_COLLAPSE, data: { filterSetId: filterSetId, filter: filter, itemId: itemId } };
};

var actionsForFilterSet = exports.actionsForFilterSet = function actionsForFilterSet(filterSetId) {
  return {
    filterSet: filterSetId,
    toggleFilterCollapse: toggleFilterCollapse.bind(null, filterSetId),
    toggleFilterSetCollapse: toggleFilterSetCollapse.bind(null, filterSetId),
    collapseFilter: collapseFilter.bind(null, filterSetId),
    collapseFilterSet: collapseFilterSet.bind(null, filterSetId),
    expandFilter: expandFilter.bind(null, filterSetId),
    expandFilterSet: expandFilterSet.bind(null, filterSetId),
    addFilter: addFilter.bind(null, filterSetId),
    setClean: setClean.bind(null, filterSetId),
    clearFilter: clearFilter.bind(null, filterSetId),
    clearFilterSet: clearFilterSet.bind(null, filterSetId),
    toggleItemId: toggleItemId.bind(null, filterSetId),
    setItemIdSelected: setItemIdSelected.bind(null, filterSetId),
    setFilterValue: setFilterValue.bind(null, filterSetId),
    toggleFilterParentCollapse: toggleFilterParentCollapse.bind(null, filterSetId)
  };
};

var initialState = {};

var initialFilterSetState = {
  filters: {},
  dirty: false,
  filtered: false
};

var initialFilterState = {
  itemsById: {},
  parentedItemIds: {},
  countSelected: 0,
  itemIdSelected: {},
  parentIdPartialSelected: {},
  parentIdExpanded: {},
  expanded: false,
  filtered: false
};

var recursivelyGetChildIds = function recursivelyGetChildIds(map, start) {
  return map[start].reduce(function (children, child) {
    return children.concat(map[child] ? recursivelyGetChildIds(map, child) : [child]);
  }, []);
};

var calculateParentStates = function calculateParentStates(parentMap, itemIdSelected) {
  return (0, _keys2.default)(parentMap).filter(function (parent) {
    return parent !== '0' && parent !== 'root';
  }).reduce(function (memo, parentId) {
    var childIds = recursivelyGetChildIds(parentMap, parentId);
    if (childIds.some(function (child) {
      return itemIdSelected[child];
    })) {
      memo.parentIdPartialSelected[parentId] = true;
    }
    return memo;
  }, {
    parentIdPartialSelected: {}
  });
};

var filtered = function filtered(filter) {
  return !!(0, _keys2.default)(filter.itemIdSelected || {}).length || !!filter.isValueFilter && filter.value !== null;
};

var filteredSet = function filteredSet(filters) {
  return (0, _keys2.default)(filters || {}).some(function (filter) {
    return filters[filter].filtered;
  });
};

var setFilterFilteredFlag = function setFilterFilteredFlag(filter, state) {
  return (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, state[filter], {
    filtered: filtered(state[filter])
  })));
};

var setFilterSetFilteredFlag = function setFilterSetFilteredFlag(filterSetId, state) {
  return (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
    filtered: filteredSet(state[filterSetId].filters)
  })));
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = action.data || {},
      filterSetId = _ref.filterSetId,
      filter = _ref.filter,
      itemId = _ref.itemId,
      itemIds = _ref.itemIds,
      options = _ref.options,
      value = _ref.value;

  switch (action.type) {
    case ADD_FILTER:
      return (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId] || initialFilterSetState, {
        filters: (0, _extends21.default)({}, state[filterSetId] ? state[filterSetId].filters : {}, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, initialFilterState, state[filterSetId] ? state[filterSetId].filters[filter] : {}, {
          exclusive: options && options.exclusive,
          filterable: options && options.filterable,
          isValueFilter: options && options.valueFilter,
          name: options && options.name,
          value: options && options.value,
          itemIdSelected: options && !options.exclusive && options.selected || {},
          countSelected: options && (0, _keys2.default)(options.selected || {}).length,
          itemsById: action.data.items.reduce(function (memo, item) {
            return (0, _extends21.default)({}, memo, (0, _defineProperty3.default)({}, item.id, item));
          }, {}),
          parentedItemIds: action.data.relationships ? action.data.relationships : { root: action.data.items.map(function (item) {
              return item.id;
            }) },
          filtered: !!(options && (options.selected || options.value))
        })))
      })));
    case SET_FILTER_VALUE:
      return setFilterSetFilteredFlag(filterSetId, (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
        dirty: true,
        filters: (0, _extends21.default)({}, setFilterFilteredFlag(filter, (0, _extends21.default)({}, state[filterSetId].filters, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, state[filterSetId].filters[filter], {
          value: value,
          dirty: true
        })))))
      }))));

    case SET_ITEM_ID_SELECTED:
      {
        var itemIdSelected = itemIds.reduce(function (object, id) {
          object[id] = true;
          return object;
        }, {});

        return setFilterSetFilteredFlag(filterSetId, (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
          dirty: true,
          filters: (0, _extends21.default)({}, setFilterFilteredFlag(filter, (0, _extends21.default)({}, state[filterSetId].filters, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, state[filterSetId].filters[filter], {
            itemIdSelected: itemIdSelected,
            countSelected: (0, _keys2.default)(itemIdSelected).length
          }, calculateParentStates(state[filterSetId].filters[filter].parentedItemIds, itemIdSelected))))))
        }))));
      }
    case TOGGLE_FILTER_COLLAPSE:
    case COLLAPSE_FILTER:
    case EXPAND_FILTER:
      return (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
        filters: (0, _keys2.default)(state[filterSetId].filters).reduce(function (set, thisFilterId) {
          var existingExpandedStatus = state[filterSetId].filters[thisFilterId].expanded;
          var nextExpandedStatus = void 0;

          if (action.type === TOGGLE_FILTER_COLLAPSE) {
            nextExpandedStatus = !existingExpandedStatus;
          } else if (action.type === COLLAPSE_FILTER) {
            nextExpandedStatus = false;
          } else if (action.type === EXPAND_FILTER) {
            nextExpandedStatus = true;
          }

          return (0, _extends21.default)({}, set, (0, _defineProperty3.default)({}, thisFilterId, (0, _extends21.default)({}, state[filterSetId].filters[thisFilterId], {
            expanded: !filter || thisFilterId === filter ? nextExpandedStatus : existingExpandedStatus
          })));
        }, {})
      })));
    case SET_CLEAN:
      return (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
        dirty: false
      })));
    case CLEAR_FILTER:
      return setFilterSetFilteredFlag(filterSetId, (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
        dirty: true,
        filters: (0, _keys2.default)((0, _deep.deepExtract)(filterSetId + '.filters', state, {})).reduce(function (set, thisFilterId) {
          return (0, _extends21.default)({}, setFilterFilteredFlag(thisFilterId, (0, _extends21.default)({}, set, (0, _defineProperty3.default)({}, thisFilterId, (0, _extends21.default)({}, state[filterSetId].filters[thisFilterId], !filter || thisFilterId === filter ? {
            countSelected: 0,
            itemIdSelected: {},
            parentIdPartialSelected: {},
            value: null
          } : {})))));
        }, {})
      }))));
    case TOGGLE_ITEM_ID:
      {
        var currentFilterData = state[filterSetId].filters[filter];
        var _itemIdSelected = (0, _extends21.default)({}, currentFilterData.itemIdSelected);

        itemIds.forEach(function (thisItemId) {
          if (currentFilterData.exclusive) {
            _itemIdSelected = (0, _defineProperty3.default)({}, thisItemId, true);
          } else if (currentFilterData.parentedItemIds[thisItemId]) {
            // Clicked Parent
            // Parent was selected, deselect it.
            if (_itemIdSelected[thisItemId]) {
              delete _itemIdSelected[thisItemId];
              // Parent was not selected/partially selected, deselect all children & select parent.
            } else {
              recursivelyGetChildIds(currentFilterData.parentedItemIds, thisItemId).forEach(function (item) {
                return delete _itemIdSelected[item];
              });
              _itemIdSelected[thisItemId] = true;
            }
            // Clicked selected child, deselect it.
          } else if (_itemIdSelected[thisItemId]) {
            delete _itemIdSelected[thisItemId];
            // Clicked deselected child, select it & deselect parent if it's selected.
          } else {
            var parentId = currentFilterData.itemsById[thisItemId].parent_id;
            if (_itemIdSelected[parentId]) {
              delete _itemIdSelected[parentId];
            }
            _itemIdSelected[thisItemId] = true;
          }
        });

        return setFilterSetFilteredFlag(filterSetId, (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
          dirty: true,
          filters: (0, _extends21.default)({}, setFilterFilteredFlag(filter, (0, _extends21.default)({}, state[filterSetId].filters, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, state[filterSetId].filters[filter], {
            itemIdSelected: _itemIdSelected,
            countSelected: (0, _keys2.default)(_itemIdSelected).length
          }, calculateParentStates(state[filterSetId].filters[filter].parentedItemIds, _itemIdSelected))))))
        }))));
      }
    case TOGGLE_FILTER_PARENT_COLLAPSE:
      {
        var parentIdExpanded = (0, _extends21.default)({}, state[filterSetId].filters[filter].parentIdExpanded);

        if (parentIdExpanded[itemId]) {
          delete parentIdExpanded[itemId];
        } else {
          parentIdExpanded[itemId] = true;
        }
        return setFilterSetFilteredFlag(filterSetId, (0, _extends21.default)({}, state, (0, _defineProperty3.default)({}, filterSetId, (0, _extends21.default)({}, state[filterSetId], {
          dirty: true,
          filters: (0, _extends21.default)({}, setFilterFilteredFlag(filter, (0, _extends21.default)({}, state[filterSetId].filters, (0, _defineProperty3.default)({}, filter, (0, _extends21.default)({}, state[filterSetId].filters[filter], {
            parentIdExpanded: parentIdExpanded
          })))))
        }))));
      }
    default:
      return state;
  }
}